import type { ConfirmMessage } from '@/models/ConfirmMessage';

import { useAppDispatch } from '../store';
import { setConfirmationMessage, setConfirmationMessageValues } from '../store/slices/application-data';

export interface IConfirmContext {
  show: boolean;
  text: string;
}

let resolveCallback;
function useConfirm() {
  const dispatch = useAppDispatch();

  const fuelConfirm = async (text): Promise<boolean> => {
    await dispatch(setConfirmationMessage(text));

    return new Promise((res, rej) => {
      resolveCallback = res;
    });
  };

  const onConfirm = async () => {
    await dispatch(setConfirmationMessage(null));
    await dispatch(setConfirmationMessageValues(null));
    resolveCallback(true);
  };

  const onCancel = async () => {
    await dispatch(setConfirmationMessage(null));
    await dispatch(setConfirmationMessageValues(null));
    resolveCallback(false);
  };

  const vnConfirmFn = async (payload: string | Partial<ConfirmMessage>): Promise<boolean> => {
    const message: ConfirmMessage =
      typeof payload === 'string'
        ? {
            open: true,
            title: 'Confirm',
            message: payload,
          }
        : {
            open: true,
            title: 'Confirm',
            confirmText: 'Confirm',
            cancelText: 'Cancel',
            ...payload,
          };

    await dispatch(setConfirmationMessageValues(message));

    return new Promise((resolve) => {
      resolveCallback = resolve;
    });
  };

  return { fuelConfirm, onConfirm, onCancel, vnConfirmFn };
}

export default useConfirm;
